

<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      noDataText="Nenhuma Carteira de Cobrança Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="
                p-4
                shadow-drop
                rounded-lg
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                w-32
              "
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="perfis.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Perfil ------------>
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="opemModalInsertEdit({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Carteira</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Perfil ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Nome</vs-th>
        <vs-th sort-key="Nome">Tipo</vs-th>
        <vs-th sort-key="Nome">Número Carteira</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.nomeCarteira }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.tipoCarteira }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.numeroCarteira }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  v-tooltip="'Editar'"
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="opemModalInsertEdit(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Perfil ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <Modal
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
      <formCarteiraCobranca
        :dados="dadosSideBar"
        @concluido="concluido"
      ></formCarteiraCobranca>
    </Modal>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../Includes/SideBar";
import service from "../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "../../components/ModalInfo";
import formCarteiraCobranca from "./../forms/formCarteiraCobranca.vue";
import Modal from "../../components/Modal.vue";
export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    formCarteiraCobranca,
    Modal
  },
  props: ["subjectPermission"],
  data() {
    return {
      idEmpresa: null,
      modalForm: false,
      dadosSideBar: {},
      controllerGeral: "CarteiraCobranca",
      formSideBar: "CarteiraCobranca",
      entidade: "Carteira de Cobrança",
      titleSideBar: "Adicionar Carteira de Cobrança",
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    closeModais() {
      this.modalForm = false;
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idCarteira);
        });
        service
          .post(this.controllerGeral, "Inativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro inativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idCarteira);
        });
        service
          .post(this.controllerGeral, "Reativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro reativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    buscaDados() {
      this.closeModais();
      this.selected = [];
      this.$vs.loading();
      service
        .getAll(this.controllerGeral, {}, "list/idEmpresa=" + this.idEmpresa)
        .then((res) => {
          this.itens = [];
          res.data.forEach((element) => {
            element.dadosBeneficiario = JSON.parse(element.dadosBeneficiario);
            element.dadosArquivoRemessa = JSON.parse(
              element.dadosArquivoRemessa
            );
            element.dadosGalaxy = JSON.parse(element.dadosGalaxy);

            this.itens.push(element);
          });
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != "createdAt" &&
                element != "updatedAt" &&
                element != "deletedAt" &&
                element.indexOf("id") != 0 &&
                element != "dadosBeneficiario" &&
                element != "dadosArquivoRemessa"
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    opemModalInsertEdit(dados) {
      dados.idCarteira == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.modalForm = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idCarteira == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style >
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
</style>
<!------------ END STYLE ------------>
